import React from 'react';

function WebDesignUiUxSection() {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="webdesign-uiux-section">
      <div className="container webdesign-uiux-container">
        {/* Left Column: Text Content */}
        <div className="webdesign-uiux-left">
          <h2 className="webdesign-uiux-title">
            Visually Appealing and Brand Building UI/UX Designs
          </h2>

          <div className="webdesign-uiux-subtitle-box">
            <div className="webdesign-uiux-red-bar"></div>
            <h3 className="webdesign-uiux-subtitle">
              Designs That Present Your Brand Beautifully
            </h3>
          </div>

          <p className="webdesign-uiux-desc">
            A web design is not just an interface, It is the main component of your brand’s identity. <a href="/web-design/" className="webdesign-uiux-link">Responsive web design</a> is the outcome of creativity combined with proficiency that expresses the web presence of your business. That is why businesses must go for a professional web design company in Pakistan. An agency dedicated solely to helping your business grow — that’s exactly who we are.
          </p>

          <p className="webdesign-uiux-desc">
            We deliver visually appealing and brand building UI/UX designs that captivate your users and deeply resonate with your core values and messaging. Get affordable web design services to craft intuitive and the best user experiences (UX) that effectively guide your audience. Our web design company in Pakistan is ready to drive engagements and conversions.
          </p>

          <button className="btn-webdesign-scrap-cta" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Mobile UI Screens Showcase Image */}
        <div className="webdesign-uiux-right">
          <div className="webdesign-uiux-img-wrapper">
            <img 
              src="/assets/images/web-design/web-img6.jpg" 
              alt="Visually Appealing and Brand Building UI/UX Designs" 
              className="webdesign-uiux-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDesignUiUxSection;
